import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Dot, useNestedPopoverMenu } from '@frontend/design-system';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  iconOnly?: boolean;
  shouldShowDot?: boolean;
  onClick?: () => void; // used for side panel model
  getTriggerProps?: ReturnType<typeof useNestedPopoverMenu>['getTriggerProps']; // used for popover
  trackingId?: string;
}

export const FilterButton = ({
  iconOnly,
  shouldShowDot,
  onClick,
  getTriggerProps,
  trackingId,
  ...restProps
}: Props) => {
  const { t } = useTranslation('schedule');

  const triggerProps = getTriggerProps?.() || {};
  return (
    <Button
      variant='secondary'
      iconName='filter-alt'
      trackingId={trackingId}
      onClick={onClick}
      {...triggerProps}
      {...restProps}
    >
      {shouldShowDot && (
        <Dot
          color='primary'
          css={{
            width: theme.spacing(1),
            height: theme.spacing(1),
            top: 6,
            left: 22,
            border: `1px solid ${theme.colors.white}`,
          }}
        />
      )}
      {/* Need to keep empty space to keep showing it as bordered button */}
      {iconOnly ? ' ' : t('Filter')}
    </Button>
  );
};
